import type { ApiFetcher } from "./maxes.js";
import { AthleteTargets } from "./schemas/program.js";

// ME-3 — the read for the athlete's own weekly-targets doc (GET /api/me/targets).
// Self (no athleteSub) or a coach reading an athlete's targets (?athleteSub).
// Mirrors fetchMaxesDetailed's shape (typed, athlete-scoped, parse-and-null on
// failure) so the two athlete-scoped reads stay one convention, not two hand-
// rolled copies. The GET always returns a body (create-if-absent sentinel), so
// `null` means the read or parse failed — never "the athlete has no targets"
// (that is a LOADED doc with empty items).
export const fetchAthleteTargets = async (
  apiFetch: ApiFetcher,
  athleteSub?: string,
): Promise<AthleteTargets | null> => {
  const q = athleteSub ? `?athleteSub=${encodeURIComponent(athleteSub)}` : "";
  try {
    return AthleteTargets.parse(await apiFetch<unknown>(`/api/me/targets${q}`));
  } catch {
    return null;
  }
};
